/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AllergyApi } from '../api/allergy.api';
import { switchMap, map } from 'rxjs/operators';
import { Allergy,AllergyData } from '../../../interfaces/masters/allergy';

@Injectable()
export class AllergyService extends AllergyData {

  constructor(private api: AllergyApi) {
    super();
  }


  list(url: string): Observable<Allergy[]> {
    return this.api.list(url);
  }

  getById(url: string): Observable<Allergy> {
    return this.api.getById(url);
  }

  create(url: string, data: Allergy): Observable<Allergy> {
    return this.api.add(url, data);
  }

  createDataLoad(url: string, data: any[]): Observable<any[]> {
    return this.api.createDataLoad(url, data);
  }


  update(url: string, data: Allergy): Observable<Allergy> {
    return this.api.update(url, data);
  }

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
